var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrap_title"},[_c('div',{staticClass:"title_text"},[_c('h1',[_vm._v(_vm._s(_vm.get_about_us.title))])]),_c('div',{staticClass:"title_desc"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.get_about_us.description)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }